var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-select',{staticClass:"mr-12",attrs:{"disabled":_vm.disabled,"clearable":true,"error-messages":_vm.getErrors,"items":_vm.enumItems,"label":_vm.getLabelText(),"required":!_vm.isOptional,"value":_vm.select,"item-text":"value","item-value":"key"},on:{"change":_vm.onValueChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }